module.exports = __webpack_public_path__ + "assets/images/1-SUCCESS.7747cb9f.svg";